import React, { useEffect, useRef } from "react";
import styled from "styled-components";

export const VideoBackground = () => {
  const videoRef: any = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.8;
    }
  }, []);

  return (
    <VideoContainer>
      <Video ref={videoRef} autoPlay loop muted>
        <source
          src="https://cdn.coverr.co/videos/coverr-the-perfect-wave-2027/1080p.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </Video>
    </VideoContainer>
  );
};

const VideoContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
`;

const Video = styled.video`
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
